import profileService from '@/services/profile/profile-service';
import store from '@/store/index';
import { COMPLIANCE_LOGO_LIST } from './constants/compliance-logo-list';
import { ERROR_DETAILS } from '../../constants/error-details';

const state = {
	logosList: COMPLIANCE_LOGO_LIST,
	selectedLogos: [],
	isEdited: false,
	complianceLogoSelected: true,
};

const mutations = {
	SELECT_LOGO(state, index) {
		state.selectedLogos = [];
		state.selectedLogos.push({
			name: state.logosList[index].name,
			value: state.logosList[index].index.toString(),
			uri: state.logosList[index].backgroundImage,
		});
	},

	SET_COMPLIANCE_LOGOS(state, logos) {
		if (logos !== null && logos !== undefined && logos.length > 0) {
			state.selectedLogos = [];
			const index = logos[0].value - 1 < 0 ? 0 : logos[0].value - 1;
			state.selectedLogos.push({
				name: state.logosList[index].name,
				value: state.logosList[index].index,
				uri: state.logosList[index].backgroundImage,
			});
			state.complianceLogoSelected = state.selectedLogos.length > 0;
		} else {
			state.complianceLogoSelected = false;
		}
	},

	LOGOS_ISEDITED(state, value = false) {
		state.isEdited = value;
	},

	//TODO: TECH DEBT, this is aways true.  Since it used in a few place it needs to be fixed carefully.
	SAVE_LOGOS(state, logos) {
		state.complianceLogoSelected = true;
	},
};

const actions = {
	selectLogo({ commit, state }, logo) {
		const permissionName = 'EditAComplianceLogo';
		// if role is active let commits happen
		if (!store.getters.roleIsNotActive(permissionName)) {
			commit('SELECT_LOGO', logo);
			commit('LOGOS_ISEDITED', true);
		}
	},

	async saveLogos({ commit, dispatch }, { contactId, selectedLogos }) {
		try {
			const complianceLogos = {
				contactId,
				complianceLogo: selectedLogos,
			};
			const { data } = await profileService.saveComplianceLogos(
				complianceLogos,
			);
			if (data === true) {
				commit('LOGOS_ISEDITED', false);
				commit('SAVE_LOGOS', selectedLogos);
				return true;
			} else {
				store.dispatch('showErrorModal', {
					errorDetails: ERROR_DETAILS.SAVE_COMPLIANCE_LOGO,
				});
				return false;
			}
		} catch (error) {
			store.dispatch('showErrorModal', {
				errorDetails: ERROR_DETAILS.SAVE_COMPLIANCE_LOGO,
			});
			return false;
		}
	},
	async getComplianceLogos({ commit }, complianceLogos) {
		commit('SET_COMPLIANCE_LOGOS', complianceLogos);
	},
};

export default {
	state,
	actions,
	mutations,
};
